export default __webpack_public_path__ + "static/media/gallery-img-4.8b19bc6a.jpg";